import React from 'react';
import { GetTermsEmbed } from '../components/GetTermsEmbed';
export function Privacy() {
  return <section className="w-full bg-white" data-id="element-342" data-mp="2wkgemkfp4y77">
      <article className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20 lg:py-24" aria-labelledby="privacy-policy-title" data-id="element-343" data-mp="2wli1dm62r94r">
        <header className="border-b border-border pb-8 sm:pb-10" data-id="element-344" data-mp="36hbcd145aukf">
          <h1 id="privacy-policy-title" className="font-heading text-3xl font-bold tracking-tight text-deep-navy sm:text-4xl" data-id="element-345" data-mp="36fryfh5yovlt">
            プライバシーポリシー
          </h1>
        </header>

        <div className="pt-10 text-text sm:pt-12" data-id="element-346" data-mp="3u7fcgyi4kc6o">
          <GetTermsEmbed documentName="privacy" data-id="element-347" data-mp="3u6x9zk4vd1qb" />
        </div>
      </article>
    </section>;
}